export default __webpack_public_path__ + "static/media/Ballroll_00248.1cdbd5ad.png";